// SPDX-License-Identifier: AGPL-3.0-or-later

export const NATIVE_TITLEBAR_CONTROL_ATTR = 'data-window-control';

export type NativeTitlebarControlName = 'minimize' | 'maximize' | 'close';
export type NativeTitlebarLayout = 'macos' | 'controls';

export const NATIVE_TITLEBAR_CLASS = {
	root: 'fluxer-native-titlebar',
	left: 'fluxer-native-titlebar__left',
	wordmark: 'fluxer-native-titlebar__wordmark',
	spacer: 'fluxer-native-titlebar__spacer',
	controls: 'fluxer-native-titlebar__controls',
	control: 'fluxer-native-titlebar__control',
	controlClose: 'fluxer-native-titlebar__control--close',
} as const;

export const NATIVE_TITLEBAR_WORDMARK_VIEWBOX = '0 0 1519 366';

export const NATIVE_TITLEBAR_WORDMARK_PATHS: ReadonlyArray<string> = [
	'M105.4 258.3 C74.3 258.3,48.9 248.1,29.4 227.9 C9.8 207.7,-0 181.3,-0 148.8 C-0 114.5,9.9 86.8,29.8 65.6 C49.7 44.4,76 33.8,108.8 33.8 C139.8 33.8,164.9 43.9,184 64.2 C203.1 84.5,212.7 111.2,212.7 144.4 C212.7 178.5,202.8 206,182.9 226.9 C163.1 247.8,137.2 258.3,105.4 258.3 Z M107.5 75.9 C90.3 75.9,76.7 82.3,66.6 95.2 C56.5 108,51.5 125.1,51.5 146.2 C51.5 167.7,56.5 184.7,66.6 197.3 C76.7 209.8,89.9 216,106.3 216 C123.1 216,136.5 209.9,146.4 197.8 C156.3 185.6,161.2 168.7,161.2 147.2 C161.2 124.7,156.4 107.1,146.8 94.6 C137.2 82.1,124.1 75.9,107.5 75.9 Z M490.1 254.5 L442.4 254.5 L442.4 166.1 C442.4 143.6,434.2 132.3,417.6 132.3 C409.8 132.3,403.3 135.7,398.4 142.5 C393.5 149.2,391 157.6,391 167.7 L391 254.5 L343.1 254.5 L343.1 165.2 C343.1 143.3,335 132.3,318.8 132.3 C310.6 132.3,304.1 135.5,299.2 142 C294.3 148.5,291.8 157.2,291.8 168.3 L291.8 254.5 L244 254.5 L244 99.5 L291.8 99.5 L291.8 123.7 L292.4 123.7 C297.4 115.4,304.3 108.7,313.3 103.5 C322.2 98.3,331.9 95.7,342.5 95.7 C364.4 95.7,379.4 105.3,387.5 124.6 C399.3 105.3,416.7 95.7,439.6 95.7 C473.3 95.7,490.1 116.5,490.1 158.1 Z M677.7 254.5 L630 254.5 L630 168.3 C630 144.3,621.4 132.3,604.3 132.3 C596 132.3,589.2 135.5,583.8 141.9 C578.5 148.2,575.8 156.3,575.8 166.1 L575.8 254.5 L528 254.5 L528 99.5 L575.8 99.5 L575.8 124 L576.4 124 C587.8 105.1,604.4 95.7,626.2 95.7 C660.5 95.7,677.7 117,677.7 159.6 Z M739.7 75 C731.7 75,725 72.6,719.9 67.8 C714.8 63,712.2 57.1,712.2 50.1 C712.2 43,714.8 37.1,719.9 32.6 C725 28,731.7 25.8,739.7 25.8 C747.9 25.8,754.5 28,759.6 32.6 C764.7 37.1,767.3 43,767.3 50.1 C767.3 57.4,764.7 63.3,759.6 68 C754.5 72.6,747.9 75,739.7 75 Z M763.3 254.5 L715.5 254.5 L715.5 99.5 L763.3 99.5 Z M989 37.4 L914.3 254.5 L858.9 254.5 L785 37.4 L837.7 37.4 L882.9 188.5 C885.3 196.7,886.8 203.9,887.3 210.1 L888.2 210.1 C888.9 203.4,890.5 195.9,892.9 187.9 L937.9 37.4 Z M1158 99.5 L1095 266.9 C1079.9 307.1,1057 327.3,1026.6 327.3 C1015 327.3,1005.4 326,998 323.3 L998 285.2 C1004.3 288.9,1011.2 290.8,1018.7 290.8 C1031 290.8,1039.6 285,1044.4 273.4 L1052.6 254.2 L989.6 99.5 L1042.6 99.5 L1071.5 193.8 C1073.3 199.6,1074.8 206.5,1075.8 214.5 L1076.4 214.5 C1077.3 208.7,1078.9 201.8,1081.4 194.1 L1110.6 99.5 Z M1225.6 236.5 L1225 236.5 L1225 254.5 L1177.2 254.5 L1177.2 25 L1225 25 L1225 122.8 L1225.6 122.8 C1237.4 104.7,1254.2 95.7,1276 95.7 C1296 95.7,1311.4 102.6,1322.2 116.3 C1333 130,1338.4 148.8,1338.4 172.6 C1338.4 198.4,1332.1 219.2,1319.5 234.8 C1306.9 250.4,1290 258.3,1268.9 258.3 C1249.8 258.3,1235.4 251,1225.6 236.5 Z M1224.3 171.1 L1224.3 187 C1224.3 197,1227.1 205.2,1232.9 211.8 C1238.6 218.3,1246 221.6,1255 221.6 C1265.9 221.6,1274.3 217.4,1280.3 209 C1286.3 200.6,1289.3 188.6,1289.3 173.2 C1289.3 160.4,1286.6 150.4,1281.1 143.1 C1275.6 135.9,1267.8 132.3,1257.6 132.3 C1248 132.3,1240 135.9,1233.7 143.1 C1227.4 150.2,1224.3 159.6,1224.3 171.1 Z M1508.7 190.6 L1407.6 190.6 C1409.2 213.1,1423.4 224.4,1450.1 224.4 C1467.2 224.4,1482.1 220.3,1495.1 212.2 L1495.1 246.8 C1480.7 254.4,1462.1 258.3,1439.2 258.3 C1414.2 258.3,1394.7 251.3,1380.9 237.4 C1367.1 223.6,1360.2 204.2,1360.2 179.4 C1360.2 153.7,1367.7 133.3,1382.6 118.2 C1397.5 103.2,1415.9 95.7,1437.7 95.7 C1460.3 95.7,1477.8 102.4,1490.1 115.8 C1502.5 129.2,1508.7 147.5,1508.7 170.5 Z M1464.3 161.2 C1464.3 139,1455.3 127.9,1437.4 127.9 C1429.7 127.9,1423.1 131.1,1417.5 137.5 C1411.9 143.8,1408.5 151.7,1407.3 161.2 Z',
];

export const NATIVE_TITLEBAR_CONTROL_ICON_PATH = {
	minimize: 'M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z',
	maximize:
		'M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204Z',
	restore:
		'M180,64H40A12,12,0,0,0,28,76V216a12,12,0,0,0,12,12H180a12,12,0,0,0,12-12V76A12,12,0,0,0,180,64ZM168,204H52V88H168ZM228,40V180a12,12,0,0,1-24,0V52H76a12,12,0,0,1,0-24H216A12,12,0,0,1,228,40Z',
	close:
		'M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z',
} as const;

export type NativeTitlebarControlIconName = keyof typeof NATIVE_TITLEBAR_CONTROL_ICON_PATH;

export function nativeTitlebarControlIconSvg(icon: NativeTitlebarControlIconName): string {
	return (
		'<svg viewBox="0 0 256 256" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
		`<path d="${NATIVE_TITLEBAR_CONTROL_ICON_PATH[icon]}"/></svg>`
	);
}

export function nativeTitlebarWordmarkSvg(className: string = NATIVE_TITLEBAR_CLASS.wordmark): string {
	const paths = NATIVE_TITLEBAR_WORDMARK_PATHS.map((d) => `<path fill="currentColor" d="${d}"/>`).join('');
	return (
		`<svg class="${className}" role="img" aria-label="OmniVybe" xmlns="http://www.w3.org/2000/svg" ` +
		`fill="none" viewBox="${NATIVE_TITLEBAR_WORDMARK_VIEWBOX}">${paths}</svg>`
	);
}

interface StartupControlLabels {
	readonly minimize: string;
	readonly maximize: string;
	readonly close: string;
}

const DEFAULT_STARTUP_CONTROL_LABELS: StartupControlLabels = {
	minimize: 'Minimize window',
	maximize: 'Maximize window',
	close: 'Close window',
};

function controlButtonHtml(
	name: NativeTitlebarControlName,
	icon: NativeTitlebarControlIconName,
	label: string,
	extraClass?: string,
): string {
	const className = extraClass ? `${NATIVE_TITLEBAR_CLASS.control} ${extraClass}` : NATIVE_TITLEBAR_CLASS.control;
	return (
		`<button type="button" tabindex="-1" class="${className}" ${NATIVE_TITLEBAR_CONTROL_ATTR}="${name}" ` +
		`aria-label="${label}">${nativeTitlebarControlIconSvg(icon)}</button>`
	);
}

export function nativeTitlebarControlsHtml(labels: StartupControlLabels = DEFAULT_STARTUP_CONTROL_LABELS): string {
	return (
		`<div class="${NATIVE_TITLEBAR_CLASS.controls}">` +
		controlButtonHtml('minimize', 'minimize', labels.minimize) +
		controlButtonHtml('maximize', 'maximize', labels.maximize) +
		controlButtonHtml('close', 'close', labels.close, NATIVE_TITLEBAR_CLASS.controlClose) +
		'</div>'
	);
}

export function buildNativeTitlebarStartupHtml(layout: NativeTitlebarLayout): string {
	const brand = `<div class="${NATIVE_TITLEBAR_CLASS.left}">${nativeTitlebarWordmarkSvg()}</div>`;
	const spacer = `<div class="${NATIVE_TITLEBAR_CLASS.spacer}"></div>`;
	if (layout === 'macos') {
		return `${spacer}${brand}`;
	}
	return `${brand}${spacer}${nativeTitlebarControlsHtml()}`;
}
